import { useEffect, useState } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { runSync } from '@mdx-js/mdx';
import * as runtime from 'react/jsx-runtime';

import '../styles/generic.css';

import { _ } from '../utils/l10n';
import { ReadMoreButton } from './generic/ReadMoreButton';
import { compileMDX } from '../utils/compileMDX';
import { useExpandable } from '../utils/useExpandable';
export interface BaseDetailSummaryItemProps {
  /**
   * Detail summary title
   */
  title: string;
  /**
   * Detail summary description
   */
  description: string;
  /**
   * Detail summary description
   */
  longDesc?: string;
}

export const DetailSummaryItemInfo = ({ title, description, longDesc }: BaseDetailSummaryItemProps) => {
  // @todo introduce custom reusable hook
  const [HTMLContent, setHTMLContent] = useState('');
  useEffect(() => {
    if (!longDesc) return;
    const code = compileMDX(longDesc);
    const { default: Content } = runSync(code, runtime);
    setHTMLContent(Content());
  }, []);

  const [showReadMore, setShowReadMore] = useState(false);
  const { ref, content, onToggle } = useExpandable<HTMLDivElement>({
    content: <div className="description solution-long-desc">{HTMLContent}</div>,
  });

  return (
    <div
      className="detail-summary-item-info"
      ref={ref}
    >
      <h2
        className="detail-summary-item-title"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
      />
      <div
        className="description"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
      />
      {!!longDesc && (
        <>
          {content}
          <ReadMoreButton
            isOpen={showReadMore}
            onClick={() => {
              setShowReadMore(!showReadMore);
              onToggle();
            }}
          />
        </>
      )}
    </div>
  );
};
